<template>
  <a-modal
          title="监测方案"
          :okText="!formState.id?'确认并启动':'确定'"
          cancelText="取消"
          width="1000px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="监测方案名称" prop="name">
            <a-input :disabled="!!formState.id" v-model="formState.name"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="监测方案级别" prop="level">
            <a-ext-local-dic-select :disabled="!!formState.id" dic-key="MonitPlanLevel" v-model="formState.level"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="监测类型" prop="type">
            <a-ext-local-dic-select :disabled="!!formState.id" dic-key="MonitPlanType" v-model="formState.type"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="发布来源" prop="source">
            <a-input  :disabled="!!formState.id"  v-model="formState.source"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="上传附件" prop="planFile">
            <a-ext-upload  :disabled="!!formState.id"  v-model="formState.planFile"></a-ext-upload>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span:24}"  prop="childs">
            <a-ext-add-monit-project :disabled="!!formState.id" v-model="formState.childs"></a-ext-add-monit-project>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import AExtUpload from '../../../components/AntDesignExt/All/AExtUpload'
import AExtAddMonitProject from '../../../components/AntDesignExt/All/AExtAddMonitProject'
import {addorUpdateMonitPlan as saveApi, getMonitPlanById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';

export default {
    name: "FormModel",
    components: {
        AExtLocalDicSelect, AExtUpload, AExtAddMonitProject,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                name: '',
                level: '',
                type: '',
                source: '',
                plan_file: '',
                childs: [],
            },
            rules: {
                name: FormRules.withName('监测方案名称').string(1, 200).isRequired().create(),
                level: FormRules.withName('监测方案级别').string(1, 50).isRequired().create(),
                type: FormRules.withName('监测类型').string(1, 50).isRequired().create(),
                source: FormRules.withName('发布来源').string(1, 50).isRequired().create(),
                planFile: FormRules.withName('上传附件').callback((value, field) => {
                    if (!value.name) {
                        return new Error('必须上传附件');
                    }
                }).isRequired().create(),
                childs: FormRules.withName('添加监测项目').callback((value, field) => {
                    if (!value.length) {
                        return new Error('添加监测项目');
                    }
                }).create(),
            },

        };
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            if (this.param.id) {
                this.confirmLoading = true;
                initApi(this.param).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            if(this.formState.id) {
                this.$emit("update:visible", false)
                return;
            }
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.formState.userRegion=this.$store.state.user.address.region.code;
                    saveApi(this.formState).then((result => {
                        this.confirmLoading = false;
                        this.$emit("addMonitPlanModalClose", true)
                        this.$emit("update:visible", false)
                    })).catch(() => {
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible", false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body {
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>